var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Grid, Icon, Select } from "semantic-ui-react";
import { CustomPriceRow } from "../../admin/CustomPriceRow";
import ErrorDisplay from "../../ErrorDisplay";
import FieldWithErrorDisplay from "../../FieldWithErrorDisplay";
import { priceColumn, PriceDisplay } from "../rna-fish/EditKitForm";
import { uniqueBy } from "../rna-fish/ProbeSetForm";
import { EnzymeEnum } from "./RnaCatalog";
var ChromogenForm = /** @class */ (function (_super) {
    __extends(ChromogenForm, _super);
    function ChromogenForm(props) {
        var _this = _super.call(this, props) || this;
        _this.onChromogenChange = function (_, data) {
            var _a, _b, _c, _d, _e, _f;
            var valStr = data.value;
            var chromogen = _this.props.catalog.chromogens
                .concat([{ id: 'NONE', label: 'NONE', platformCompatibility: [], enzymeCompatibility: '', bufferCompatibility: { id: 'NONE', label: 'NONE' } }])
                .find(function (c) { return c.id === valStr; });
            if (chromogen === undefined) {
                throw new RangeError("Invalid  chromogen " + valStr);
            }
            if (_this.props.nonOtherKit) {
                _this.props.onChromogenChange({
                    chromogen: chromogen,
                    chromogenBuffer: chromogen.id === "NONE" ? { id: "NONE", label: "NONE" } : chromogen.bufferCompatibility,
                    chromogenScaleUl: chromogen.id === "NONE" ? 0 : (_b = (_a = _this.props.presetScales) === null || _a === void 0 ? void 0 : _a.chromogenScaleUl) !== null && _b !== void 0 ? _b : 0,
                    chromogenBufferScaleUl: chromogen.id === "NONE" ? 0 : (_d = (_c = _this.props.presetScales) === null || _c === void 0 ? void 0 : _c.chromogenBufferScaleUl) !== null && _d !== void 0 ? _d : 0,
                    hematoxylinScaleUl: chromogen.id === "NONE" ? 0 : (_f = (_e = _this.props.presetScales) === null || _e === void 0 ? void 0 : _e.hemotoxylinScaleUl) !== null && _f !== void 0 ? _f : 0
                }, _this.props.onUserSelection);
            }
            else {
                _this.props.onChromogenChange({
                    chromogen: chromogen,
                    chromogenScaleUl: chromogen.id === "NONE" ? 0 : _this.props.chromogenState.chromogenScaleUl,
                }, _this.props.onUserSelection);
            }
        };
        _this.onChromogenBufferChange = function (_, data) {
            var valStr = data.value;
            var chromogenBuffer = _this.props.catalog.chromogenBuffers
                .concat([{ id: 'NONE', label: 'NONE' }])
                .find(function (c) { return c.id === valStr; });
            if (chromogenBuffer === undefined) {
                throw new RangeError("Invalid  chromogen buffer " + valStr);
            }
            _this.props.onChromogenChange({
                chromogenBuffer: chromogenBuffer,
                chromogenBufferScaleUl: chromogenBuffer.id === 'NONE' ? 0 : _this.props.chromogenState.chromogenBufferScaleUl
            }, _this.props.onUserSelection);
        };
        _this.onChromogenScaleChange = function (_, data) {
            var v = data.value;
            var chromogen = v === 0 ? {
                id: 'NONE',
                label: 'NONE',
                platformCompatibility: [],
                enzymeCompatibility: '',
                bufferCompatibility: { id: 'NONE', label: 'NONE' }
            } : _this.props.chromogenState.chromogen;
            _this.props.onChromogenChange({
                chromogenScaleUl: v,
                chromogen: chromogen
            }, _this.props.onUserSelection);
        };
        _this.onChromogenBufferScaleChange = function (_, data) {
            var v = data.value;
            var chromogenBuffer = v === 0 ? {
                id: "NONE",
                label: "NONE"
            } : _this.props.chromogenState.chromogenBuffer;
            _this.props.onChromogenChange({
                chromogenBufferScaleUl: v,
                chromogenBuffer: chromogenBuffer
            }, _this.props.onUserSelection);
        };
        _this.onHematoxylinScaleChange = function (_, data) {
            var v = data.value;
            _this.props.onChromogenChange({
                hematoxylinScaleUl: v
            }, _this.props.onUserSelection);
        };
        _this.chromogenScaleSlideOptions = function () {
            return uniqueBy(_this.props.scaleOptions
                .concat(_this.props.chromogenState.chromogenScaleUl), function (s) { return s; });
        };
        _this.chromogenBufferScaleSlideOptions = function () {
            return uniqueBy(_this.props.scaleOptions
                .concat(_this.props.chromogenState.chromogenBufferScaleUl), function (s) { return s; });
        };
        _this.hematoxylinScaleSlideOptions = function () {
            return uniqueBy(_this.props.scaleOptions
                .concat(_this.props.chromogenState.hematoxylinScaleUl), function (s) { return s; });
        };
        _this.checkChromogenCompatibility = function (chromogen) {
            var _a, _b, _c, _d;
            if (_this.props.nonOtherKit) {
                return chromogen.platformCompatibility.some(function (p) { return p.id === _this.props.protocolType.id; }) &&
                    (chromogen.enzymeCompatibility === ((_b = (_a = _this.props.ampState.channels[0]) === null || _a === void 0 ? void 0 : _a.enzyme) === null || _b === void 0 ? void 0 : _b.id)
                        || ((_d = (_c = _this.props.ampState.channels[0]) === null || _c === void 0 ? void 0 : _c.enzyme) === null || _d === void 0 ? void 0 : _d.id) === EnzymeEnum.HRP_AP || !_this.props.detectEnabled);
            }
            else {
                return chromogen.platformCompatibility.some(function (p) { return p.id === _this.props.protocolType.id; });
            }
        };
        _this.checkChromogenBufferCompatibility = function (chromogenBuffer) {
            if (_this.props.nonOtherKit || _this.props.chromogenState.chromogen.id !== 'NONE') {
                return _this.props.chromogenState.chromogen.bufferCompatibility.id === chromogenBuffer.id;
            }
            else {
                return true;
            }
        };
        _this.onCustomPriceChange = function (newStateFn, callback) {
            _this.props.onChromogenChange(function (oldState) {
                return {
                    customPrice: newStateFn(oldState.customPrice)
                };
            }, callback);
        };
        return _this;
    }
    ChromogenForm.prototype.render = function () {
        var _this = this;
        return React.createElement(React.Fragment, null,
            React.createElement(Grid, { columns: 1 },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { textAlign: 'right' }, this.props.presetScales != null
                        ? React.createElement(React.Fragment, null,
                            React.createElement(Icon, { name: 'check circle', color: 'green' }),
                            React.createElement("span", { style: { color: 'green' } }, "Preset scale applied"))
                        : React.createElement(React.Fragment, null,
                            React.createElement(Icon, { name: 'warning sign', color: 'yellow' }),
                            React.createElement("span", { style: { color: '#b58900' } }, "No preset scale applied"))))),
            React.createElement(Grid, { columns: 3, stackable: true },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.errors, errorPath: '/chromogenComponent/chromogen', labelContent: 'Chromogen', labelFor: 'chromogen' },
                            React.createElement(Select, { name: 'chromogen', onChange: this.onChromogenChange, options: this.props.catalog.chromogens.filter(function (c) {
                                    return _this.checkChromogenCompatibility(c);
                                }).map(function (c) {
                                    return {
                                        text: c.label,
                                        value: c.id
                                    };
                                }).concat([{ text: 'NONE', value: 'NONE' }]), value: this.props.chromogenState.chromogen.id }))),
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.errors, errorPath: '/chromogenComponent/chromogenBuffer', labelContent: 'Chromogen Buffer', labelFor: 'chromogen-buffer', disabled: this.props.lockScales },
                            React.createElement(Select, { name: 'chromogen-buffer', onChange: this.onChromogenBufferChange, options: this.props.catalog.chromogenBuffers.filter(function (c) {
                                    return _this.checkChromogenBufferCompatibility(c);
                                }).map(function (c) {
                                    return {
                                        text: c.label,
                                        value: c.id
                                    };
                                }).concat([{ text: 'NONE', value: 'NONE' }]), value: this.props.chromogenState.chromogenBuffer.id })))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.errors, errorPath: '/chromogenComponent/chromogenScaleSlides', labelContent: React.createElement(React.Fragment, null, "Chromogen Scale"), labelFor: 'chromogen-slides', disabled: this.props.lockScales },
                            React.createElement(Select, { disabled: this.props.lockScales, name: 'chromogen-slides', onChange: this.onChromogenScaleChange, options: this.chromogenScaleSlideOptions().map(function (s) {
                                    return {
                                        text: s,
                                        value: s
                                    };
                                }), search: true, value: this.props.chromogenState.chromogenScaleUl }))),
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.errors, errorPath: '/chromogenComponent/chromogenBufferScaleSlides', labelContent: React.createElement(React.Fragment, null, "Chromogen Buffer Scale"), labelFor: 'chromogen-buffer-slides', disabled: this.props.lockScales },
                            React.createElement(Select, { disabled: this.props.lockScales, name: 'chromogen-buffer-slides', onChange: this.onChromogenBufferScaleChange, options: this.chromogenBufferScaleSlideOptions().map(function (s) {
                                    return {
                                        text: s,
                                        value: s
                                    };
                                }), search: true, value: this.props.chromogenState.chromogenBufferScaleUl }))),
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.errors, errorPath: '/chromogenComponent/hematoxylinScaleSlides', labelContent: React.createElement(React.Fragment, null, "Hematoxylin Scale"), labelFor: 'hematoxylin-slides', disabled: this.props.lockScales },
                            React.createElement(Select, { disabled: this.props.lockScales, name: 'hematoxylin-slides', onChange: this.onHematoxylinScaleChange, options: this.hematoxylinScaleSlideOptions().map(function (s) {
                                    return {
                                        text: s,
                                        value: s
                                    };
                                }), search: true, value: this.props.chromogenState.hematoxylinScaleUl }))))),
            React.createElement(Grid, { columns: 4, stackable: true },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null),
                    React.createElement(Grid.Column, null),
                    React.createElement(Grid.Column, null),
                    priceColumn(React.createElement(PriceDisplay, { loading: this.props.priceLoading, priceCents: this.props.priceCents }))),
                this.props.enableCustomPrice &&
                    React.createElement(CustomPriceRow, { customPrice: this.props.chromogenState.customPrice, defaultEffectivePriceCents: this.props.priceCents, disabled: this.props.customPriceLocked, errors: this.props.errors, errorPathPrefix: '/chromogenComponent', onPriceChange: this.onCustomPriceChange, onUserInput: this.props.onUserSelection })),
            React.createElement(ErrorDisplay, { errors: this.props.errors, errorPath: "/chromogenComponent" }));
    };
    return ChromogenForm;
}(React.PureComponent));
export default ChromogenForm;
//# sourceMappingURL=ChromogenForm.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/automated-pro/ChromogenForm.js
// module id = 592
// module chunks = 0